import { NotFound } from './theme/NotFound';
import { useParams } from 'react-router-dom';
import { IndirectCostType } from './Factoty&Production/IndirectCostType/IndirectCostType';
import { ProductiveProcessType } from './Factoty&Production/ProductiveProcessType/ProductiveProcessType';
import { LabourType } from './Factoty&Production/LabourType/LabourType';
import { ManufacturingStandars } from './Factoty&Production/ManufacturingStandars/ManufacturingStandars';
import { ProductionOrder } from './Factoty&Production/ProductionOrder/ProductionOrder';
import { ProductLine } from './Inventories-Warehouses/ProductLine/ProductLine';
import { Product } from './Inventories-Warehouses/Product/Product';
import { Store } from './Inventories-Warehouses/inventory.Store/Store';
import { AttentionOffice } from './Factoty&Production/AttentionOffice/AttentionOffice';
import { ProductionOrderProcess } from './Factoty&Production/ProductionOrderProcees/ProductionOrderProcess';
import { ProductionOrderReject } from './Factoty&Production/ProductionOrderProcees/ProductionOrderReject/ProductionOrderReject';
import { ProductionOrderForInvoice } from './Factoty&Production/ProductionOrderProcees/ProductionOrderForInvoice/ProductionOrderForInvoice';
import { ProductionOrderCatalogForRawMaterial } from './Factoty&Production/ProductionOrderProcees/ProductionOrderCatalogForRawMaterial/ProductionOrderCatalogForRawMaterial';
import { ProductionResource } from './Factoty&Production/ProductionResource/ProductionResource';
import { UBLInvoiceProductionOrder } from './Factoty&Production/UBLInvoice/UBLInvoiceProductionOrder';
import { ProductionRoute } from './Factoty&Production/ProductionRoute/ProductionRoute';
import { ImportProductionOrder } from './Factoty&Production/ImportProductionOrder/ImportProductionOrder';
import { UBLInvoiceReferralBilling } from './Factoty&Production/UBLInvoiceReferral/UBLInvoiceReferralBilling';
import { UBLInvoiceInventory } from './Inventories-Warehouses/InventoryUBLInovice/UBLInvoiceInventory';
import { ResourceCost } from './Factoty&Production/ResourceCost/ResourceCost';
import { TimeEvent } from './Factoty&Production/ManufacturingStandars/TimeEvent/TimeEvent';
import { Machines } from './Factoty&Production/Maintenance/Machines/Machines';
import { Technicians } from './Factoty&Production/Maintenance/Technicians/Technicians';
import { RequestMaintenance } from './Factoty&Production/Maintenance/RequestMaintenance/RequestMaintenance';
import { PlanMaintenance } from './Factoty&Production/Maintenance/PlanMaintenance/PlanMaintenance';
import { SpareInventoriedType } from './Factoty&Production/Maintenance/SpareInventoriedType/SpareInventoriedType';
import { ProductSupplier } from './Factoty&Production/ProductSupplier/ProductSupplier';
import { ProductCost } from './Factoty&Production/ProductionOrderProcees/ProductCost/ProductCost';
import { MaintenanceTypeItem } from './Factoty&Production/Maintenance/MaintenanceTypeItem/MaintenanceTypeItem';
import { WorkMaintenanceOrder } from './contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/WorkMaintenanceOrder/WorkMaintenanceOrder';
import { SeverityLevels } from './Factoty&Production/Maintenance/SeverityLevels/SeverityLevels';
import { ErrorTypes } from './Factoty&Production/Maintenance/ErrorTypes/ErrorTypes';
import { LocationMaintenance } from './Factoty&Production/Maintenance/LocationMaintenance/LocationMaintenance';
import { TechnicianExperticies } from './Factoty&Production/Maintenance/TechnicianExperticies/TechnicianExperticies';
import { InventoryRemissionFactory } from './RemoteAbstractAction/components/account/documents/inventoryremission/InventoryRemissionFactory/InventoryRemissionFactory';
import { UBLInvoiceFactory } from './RemoteAbstractAction/components/account/documents/ublsalesaccountantdocument/UBLInvoiceFactory/UBLInvoiceFactory';
import { QualityInspection } from './Factoty&Production/Quality/QualityInspection/QualityInspection';
import { THConstants } from './bpm/config/THConstants/THConstants';
import { QualityProductionOrder } from './Factoty&Production/Quality/QualityProductionOrder/QualityProductionOrder';
import { ProductLotCatalogByProductionOrde } from './RemoteAbstractAction/components/com/quickdataerp/actions/steps/ProductLotCatalogByProductionOrde';
import { QualityTraining } from './Factoty&Production/Quality/QualityTraining/QualityTraining';
import { QualityGarment } from './Factoty&Production/Quality/QualityGarment/QualityGarment';
import { QualityManager } from './Factoty&Production/Quality/QualityManager';
import { QualityErrorTypes } from './Factoty&Production/Quality/QualityErrors/QualityErrorTypes';
import { QualityReprocessing } from './Factoty&Production/Quality/QualityReprocessing/QualityReprocessing';
import { QualityInformationILES } from './Factoty&Production/Quality/QualityInformationILES/QualityInformationILES';
import { QualityInspectionChangeParts } from './Factoty&Production/Quality/QualityProductionOrder/QualityInspectionChangeParts/QualityInspectionChangeParts';
import { QualityMeasurementInspections } from './Factoty&Production/Quality/QualityMeasurementInspections/QualityMeasurementInspections';
import { ReportMaintenanceCostDetailed } from './Factoty&Production/Maintenance/ReportCostMaintenance/ReportMaintenanceDetailed';
import { ReportMaintenanceCostConsolidated } from './Factoty&Production/Maintenance/ReportCostMaintenance/ReportMaintenanceCostConsolidated';
import { UpcomingMaintenance } from './Factoty&Production/Maintenance/UpcomingMaintenance/UpcomingMaintenance';
import { OutputAuthorizationRequest } from './Inventories-Warehouses/OutputAuthorizationRequest/OutputAuthorizationRequest';
import { _single } from '../core/services/dataBean/EntityCatalog';

export const RouterFactory = (props: any) => {

    const { module, view, param }: any = useParams();

    const renderSwitch = (url: string) => {

        switch (url) {
            case 'tipos-costos-indirectos':
                return <IndirectCostType />;
            case 'tipos-procesos-productivos':
                return <ProductiveProcessType />;
            case 'tipos-labor':
                return <LabourType />;
            case 'fabricacion-produccion':
                return <AttentionOffice />;
            case 'estandares-fabricacion':
                return <ManufacturingStandars />;
            case 'tipos-recurso-productivo':
                return <ProductionResource />;
            case 'ordenes-produccion':
                return <ProductionOrder />;
            case 'importar-ordenes-produccion':
                return <ImportProductionOrder />;
            case 'facturación-remisiones':
                return <UBLInvoiceReferralBilling typeDocument='sell' />;
            case 'ordenes-crear-remision':
                return <UBLInvoiceProductionOrder typeDocument='sell' />;
            case 'rutas-produccion':
                return <ProductionRoute />;
            case 'tiempos-movimientos-ordenes':
                return <TimeEvent />;
            case 'costo-recusos':
                return <ResourceCost />;
            case 'ordenes-produccion-proceso':
                return <ProductionOrderProcess />;
            case 'ordenes-produccion-novedades':
                return <ProductionOrderReject />;
            case 'ordenes-produccion-facturar':
                return <ProductionOrderForInvoice />;
            case 'ordenes-produccion-material':
                return <ProductionOrderCatalogForRawMaterial />;
            case 'grupos-productos-inventarios':
                return <ProductLine />;
            case 'productos-inventarios':
                return <Product />;
            case 'solicitudes-salidas':
                return <OutputAuthorizationRequest />;
            case 'mis-solicitudes-salidas':
                return <OutputAuthorizationRequest _IDEmployee={_single.getAccountID()} />;
            case 'costos-producto':
                return <ProductCost />;
            case 'maquinas':
                return <Machines />;
            case 'tipos-mantenimientos':
                return <MaintenanceTypeItem />;
            case 'repuestos-maquinas':
                return <SpareInventoriedType />;
            case 'tecnicos-cargo':
                return <Technicians />;
            case 'historial-mantenimientos':
                return <RequestMaintenance />;
            case 'catalogo-almacenes':
                return <Store />;
            case 'remision-productos-almacen':
                return <UBLInvoiceInventory />;
            case 'planes-mantenimiento':
                return <PlanMaintenance />;
            case 'referencias-cruzadas-inventarios':
                return <ProductSupplier />;
            case 'ordenes-trabajo-mantenimientos':
                return <WorkMaintenanceOrder />;
            case 'severidades':
                return <SeverityLevels />;
            case 'tipos-errores':
                return <ErrorTypes />;
            case 'ubicaciones-mantenimientos':
                return <LocationMaintenance />;
            case 'experticies-tecnicos':
                return <TechnicianExperticies />;
            case 'remisiones-producto':
                return <InventoryRemissionFactory onChange={() => { }} isMenu />;
            case 'facturas-proyectos-pagadas':
                return <UBLInvoiceFactory onChange={() => { }} isMenu />;
            case 'calidad-insumos':
                return <QualityInspection />;
            case 'calidad-ordenes-produccion':
                return <QualityProductionOrder />;
            case "calidad-lote-producto":
                return <ProductLotCatalogByProductionOrde Inspection />;
            case "calidad-ILES":
                return <QualityInformationILES />;
            case "capacitaciones-procesos":
                return <QualityTraining />;
            case "calidad-prendas":
                return <QualityGarment />;
            case "calidad-cambios-piezas":
                return <QualityInspectionChangeParts />;
            case "calidad-reportes":
                return <QualityManager />
            case "errores-calidad":
                return <QualityErrorTypes />
            case "reprocesos-calidad":
                return <QualityReprocessing />
            case "calidad-cotas":
                return <QualityMeasurementInspections />
            case "reportes-mantenimiento-detallado":
                return <ReportMaintenanceCostDetailed />
            case "reportes-mantenimiento-consolidado":
                return <ReportMaintenanceCostConsolidated />
            case "proximos-mantenimientos":
                return <UpcomingMaintenance />
            default:
                return <NotFound />;
        }
    }

    return (
        <div className=''>
            {renderSwitch(view)}
        </div>
    );
}